/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var AssignedPermissionsFilter;
(function (AssignedPermissionsFilter) {
    AssignedPermissionsFilter["Feature"] = "FEATURE";
    AssignedPermissionsFilter["Class"] = "CLASS";
})(AssignedPermissionsFilter || (AssignedPermissionsFilter = {}));
export function AssignedPermissionsFilterFromJSON(json) {
    return AssignedPermissionsFilterFromJSONTyped(json, false);
}
export function AssignedPermissionsFilterFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function AssignedPermissionsFilterToJSON(value) {
    return value;
}
